import { Inject, Injectable } from "@angular/core";
import { DwAppInitService, DwCacheService, DwOrmDataService, DwOrmDataServiceToken, DwThemeManagerService } from "@devwareapps/devware-cap";
import { AviatorUser } from "../../shared/models/aviator-user.model";
import { map, mergeMap } from "rxjs/operators";
import { Observable, of } from "rxjs";
import { SchoolRepositoryService } from "./school-repository.service";
import { AppMetaData, DwThemeEntity, SubscriptionFeatureKeys } from "../../../meta-data/app-meta-data.service";
import { SchoolFeatures } from "../models/school-features.model";

@Injectable({
    providedIn: 'root'
})
export class SchoolBrandingService {

    private currentThemeId: any;
    private changingTheme: boolean = false;

    constructor(private themeManagerService: DwThemeManagerService,
        @Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
        private dwCacheService: DwCacheService,
        private appInitService: DwAppInitService,
        private schoolRepositoryService: SchoolRepositoryService,
    ) {

    }

    previousThemeId: any;
    previousThemeLoaded: boolean = false;

    private loadPreviousTheme() {
        if (this.previousThemeLoaded) {
            return;
        }

        this.previousThemeLoaded = true;

        this.previousThemeId = sessionStorage.getItem('previousThemeId');
    }

    private savePreviousTheme(themeId) {
        sessionStorage.setItem('previousThemeId', themeId);
    }


    setupSchoolBranding(user: AviatorUser, schoolFeatures: SchoolFeatures): Observable<boolean> {
        //this.loadPreviousTheme();

        // School features now has the correct theme id and checks for white labeling on server
        let newThemeId = schoolFeatures?.FlightSchoolThemeId;
        const appliedThemeId = (this.themeManagerService as DwThemeManagerService & { readonly currentThemeId?: number }).currentThemeId;

        if (!newThemeId || newThemeId == this.currentThemeId || newThemeId == appliedThemeId) {

            //console.log('No theme change required');
            return of(this.changingTheme);
        }

        //console.log(`Changing Theme from ${this.currentThemeId} to ${newThemeId}`);

        this.currentThemeId = newThemeId;

        this.changingTheme = true;

        this.savePreviousTheme(this.currentThemeId);

        return this.themeManagerService.applyTheme(newThemeId)
            .pipe(map(() => {
                this.changingTheme = false;
                //console.log(`Chaing Theme COMPLETE from ${this.currentThemeId} to ${newThemeId}`);

                return this.changingTheme;
            }));
    }

    setupSchoolBrandingOld(user: AviatorUser): Observable<boolean> {
        this.loadPreviousTheme();

        return this.getDefaultTheme()
            .pipe(mergeMap(defaultTheme => {

                return this.schoolRepositoryService.hasAnyFeatureWithLoad(SubscriptionFeatureKeys.WhilteLabeling, SubscriptionFeatureKeys.WhiteLabelingFullDomain)
                    .pipe(mergeMap(hasWhiteLabeling => {

                        return this.appInitService.getAppInitResult()
                            .pipe(mergeMap(result => {
                                let newThemeId = result?.ThemesConfig?.CurrentThemeId;

                                if (user.FlightSchoolBrandingThemeId) {
                                    newThemeId = user.FlightSchoolBrandingThemeId;
                                } else {
                                    if (this.previousThemeId) {
                                        // console.log(`Using previous theme ${this.previousThemeId} instead of theme ${newThemeId}`);
                                      //  newThemeId = this.previousThemeId;
                                    }
                                }

                                if (!hasWhiteLabeling) {
                                    newThemeId = defaultTheme?.ThemeId;
                                   // console.log(`No White Labeling feature - using default theme ${newThemeId}`);
                                } else {
                                    //console.log(`White Labeling feature enabled`);
                                }

                                if (!newThemeId || newThemeId == this.currentThemeId) {

                                    // console.log('No theme change required');
                                    return of(this.changingTheme);
                                }

                                //console.log(`Changing Theme from ${this.currentThemeId} to ${newThemeId}`);

                                this.currentThemeId = newThemeId;

                                this.changingTheme = true;

                                this.savePreviousTheme(this.currentThemeId);

                                return this.themeManagerService.applyTheme({
                                    ThemeId: newThemeId,
                                } as any)
                                    .pipe(map(() => {
                                        this.changingTheme = false;
                                        // console.log(`Chaing Theme COMPLETE from ${this.currentThemeId} to ${newThemeId}`);

                                        return this.changingTheme;
                                    }));
                            }));
                    }));
            }));

    }

    getDefaultTheme(): Observable<DwThemeEntity> {
        return this.dwCacheService.get('defaultThemee', this.loadDefaultTheme());
    }

    loadDefaultTheme(): Observable<DwThemeEntity> {
        const query = AppMetaData.DwTheme.CreateQueryBuilder();

        query.addFilterAnd(f => f.Equal(a => a.IsDefault, true));

        return this.dwOrmDataService.executeQuerySingle(query);
    }

}
